import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    AppBlockPort,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class ModbusResponseNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On Modbus Response';
        this.id = 'node_modbus_response';
        this.requirements = ['tios'];
        this.linkedFeature = 'general';

        this.inputs = [];

        this.outputs = [
            {
                name: 'Response',
                portId: 'response',
                params: [
                    {
                        name: 'response_data',
                        dataType: TibboDataType.WORD,
                    },
                    {
                        name: 'device_id',
                        dataType: TibboDataType.WORD,
                    },
                    {
                        name: 'register_address',
                        dataType: TibboDataType.WORD,
                    },
                    {
                        name: 'reply',
                        dataType: TibboDataType.STRING,
                    },
                ],
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;

        const links = project.getNodeLinks(this, 'response');
        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];
            blocks.push({
                location: 'callback_modbus_slave_reply',
                blockType: BlockType.CODE,
                id: this.getID(),
                template: `
    ${project.getCodeLocationStart()}${link.getSourceId()}${project.getCodeLocationEnd()}`,
            });
        }


        return blocks;
    }
}
